export const isFileDownloadable = async (url) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });

    if (!response.ok) {
      console.error(`HTTP error: ${response.status}`);
      return false;
    }

    const contentDisposition = response.headers.get('Content-Disposition');
    return contentDisposition && contentDisposition.includes('attachment');
  } catch (error) {
    console.error('Error checking file:', error);
    return false;
  }
};

export const formatFileSize = (size) => {
  if (!size) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let formattedSize = size;

  while (formattedSize >= 1024 && unitIndex < units.length - 1) {
    formattedSize /= 1024;
    unitIndex++;
  }
  return `${formattedSize.toFixed(2)} ${units[unitIndex]}`;
};

export const getFileSize = (text) => {
  if (!text) return 0;
  return new Blob([text]).size;
};
